module.exports = {
    "footer": {
        "about": "О компании",
        "about-url": "//company.yandex.ru",
        "advert": "Реклама",
        "advert-url": "//advertising.yandex.ru/kupislova.xml?advertising",
        "apps": "Мобильные приложения",
        "apps-url": "//mobile.yandex.ru",
        "stat": "Статистика",
        "termsofuse": "Лицензия на поиск",
        "termsofuse-url": "//legal.yandex.ru/termsofuse/"
    }
};